import SimulationList from '@/components/simulation/SimulationList.tsx';

export default function SimulationsPage() {
  return (
    <div className="animate-fade-in">
      <SimulationList />
    </div>
  );
}
